import { SESSION_STATUS } from "@repo/database/session-status";

export const COLORS: Record<string, string> = {
  reset: "\u001b[0m",
  dim: "\u001b[2m",
  bold: "\u001b[1m",
  red: "\u001b[31m",
  green: "\u001b[32m",
  yellow: "\u001b[33m",
  blue: "\u001b[34m",
  magenta: "\u001b[35m",
};

export const STATUS_COLORS: Record<string, string> = {
  [SESSION_STATUS.RUNNING]: "blue",
  [SESSION_STATUS.PROVISIONING]: "blue",
  [SESSION_STATUS.QUEUED]: "dim",
  [SESSION_STATUS.CREATED]: "dim",
  [SESSION_STATUS.DELIVERING]: "blue",
  [SESSION_STATUS.VERIFYING]: "blue",
  [SESSION_STATUS.WAITING_HUMAN]: "yellow",
  [SESSION_STATUS.WAITING_EXTERNAL]: "blue",
  [SESSION_STATUS.AWAITING_APPROVAL]: "yellow",
  [SESSION_STATUS.COMPLETED]: "green",
  [SESSION_STATUS.FAILED]: "red",
  [SESSION_STATUS.KILLED]: "red",
  [SESSION_STATUS.ABSTAINED]: "yellow",
};
